<template>
  <div class="ab-page">
    <div class="page-inner">
      <div v-if="isAdmin" class="grid metrics">
        <!-- 注册车辆总数 -->
        <div class="card metric-card card-primary">
          <div class="metric-top">
            <div class="metric-icon icon primary">
              <i class="el-icon-receiving" />
            </div>
            <span v-if="vehicleCount" class="badge badge-success"
              >+{{
                ((24 / (vehicleCount || 24)) * 100).toFixed(2) || "--"
              }}%</span
            >
          </div>
          <div class="metric-main">
            <div class="metric-title">注册车辆总数</div>
            <div class="metric-value">
              <count-to
                :start-val="0"
                :end-val="vehicleCount"
                :duration="2000"
              />
            </div>
            <div class="metric-sub">
              <span class="metric-sub-strong primary">今日新增 +24</span>
              <span class="metric-sub-split">|</span>
              <span>运力 {{ weightSum }}吨</span>
            </div>
          </div>
          <span class="card-corner corner-primary" />
        </div>
        <!-- 注册司机总数 -->
        <div class="card metric-card card-secondary">
          <div class="metric-top">
            <div class="metric-icon icon secondary">
              <i class="el-icon-s-custom" />
            </div>
            <span v-if="homeData.driverCount" class="badge badge-success"
              >+{{
                ((18 / (homeData.driverCount || 18)) * 100).toFixed(2) || "--"
              }}%</span
            >
          </div>
          <div class="metric-main">
            <div class="metric-title">注册司机总数</div>
            <div class="metric-value">
              <count-to
                :start-val="0"
                :end-val="homeData.driverCount"
                :duration="2000"
              />
            </div>
            <div class="metric-sub">
              <span class="metric-sub-strong secondary">今日新增 +18</span>
              <span class="metric-sub-split">|</span>
              <span>活跃率 86.4%</span>
            </div>
          </div>
          <span class="card-corner corner-secondary" />
        </div>

        <!-- 待审核事项 -->
        <div class="card metric-card card-warning">
          <div class="metric-top">
            <div class="metric-icon icon warning">
              <i class="el-icon-s-check" />
            </div>
            <span class="badge badge-danger">需处理</span>
          </div>
          <div class="metric-main">
            <div class="metric-title">待审核事项</div>
            <div class="metric-value">
              <count-to
                :start-val="0"
                :end-val="
                  homeData.driverPendingReviewCount +
                    homeData.vehiclePendingReviewCount +
                    homeData.waybillPendingReviewCount || 0
                "
                :duration="2000"
              />
            </div>
            <div class="metric-tags">
              <span class="tag">
                <span class="tag-dot warning" />司机
                {{ homeData.driverPendingReviewCount }}
              </span>
              <span class="tag">
                <span class="tag-dot primary" />车辆
                {{ homeData.vehiclePendingReviewCount }}
              </span>
              <span class="tag">
                <span class="tag-dot secondary" />运单
                {{ homeData.waybillPendingReviewCount }}
              </span>
            </div>
          </div>
          <span class="card-corner corner-warning" />
        </div>

        <!-- 今日运费总额 -->
        <div class="card metric-card card-success">
          <div class="metric-top">
            <div class="metric-icon icon success">
              <i class="el-icon-coin" />
            </div>
            <span class="badge badge-success">+23.5%</span>
          </div>
          <div class="metric-main">
            <div class="metric-title">运费总额</div>
            <div
              v-if="homeData && homeData.arrivePayTotalAmount"
              class="metric-value money"
            >
              <span>¥</span>
              <count-to
                :start-val="0"
                :end-val="
                  homeData.arrivePayTotalAmount +
                    homeData.prepayTotalAmount +
                    homeData.receiptPayTotalAmount || 0
                "
                :duration="2000"
              />
            </div>
            <div
              v-if="homeData && homeData.arrivePayTotalAmount"
              class="metric-tags"
            >
              <span class="tag">
                到付¥{{ homeData.arrivePayTotalAmount }}
              </span>
              <span class="tag"> 预付¥{{ homeData.prepayTotalAmount }} </span>
              <span class="tag">
                回单付¥{{ homeData.receiptPayTotalAmount }}
              </span>
            </div>
          </div>
          <span class="card-corner corner-success" />
        </div>
      </div>
      <!-- 货主列表 -->
      <div v-if="!isAdmin" class="grid metrics">
        <!-- 注册车辆总数 -->
        <div class="card metric-card card-primary">
          <div class="metric-top">
            <div class="metric-icon icon primary">
              <i class="el-icon-bank-card" />
            </div>
            <span class="badge badge-success">+0.35%</span>
          </div>
          <div class="metric-main">
            <div class="metric-title">预付运费</div>
            <div class="metric-value">
              ￥
              <count-to
                :start-val="0"
                :end-val="homeData.prepayTotalAmount"
                :duration="2000"
              />
            </div>
          </div>
          <div class="metric-foot" aria-label="运单数量">
            <span class="metric-foot-muted">共计</span>
            <span class="metric-foot-num">{{ homeData.prepayCount }}</span>
            <span class="metric-foot-muted">单</span>
          </div>
        </div>
        <!-- 注册司机总数 -->
        <div class="card metric-card card-secondary">
          <div class="metric-top">
            <div class="metric-icon icon secondary">
              <i class="el-icon-money" />
            </div>
            <span class="badge badge-success">+8.2%</span>
          </div>
          <div class="metric-main">
            <div class="metric-title">到付运费</div>
            <div class="metric-value">
              ￥
              {{ homeData.arrivePayTotalAmount }}
            </div>
          </div>
          <div class="metric-foot" aria-label="运单数量">
            <span class="metric-foot-muted">共计</span>
            <span class="metric-foot-num" style="color:#3b82f6;">{{
              homeData.arrivePayCount
            }}</span>
            <span class="metric-foot-muted">单</span>
          </div>
        </div>

        <!-- 待审核事项 -->
        <div class="card metric-card card-warning">
          <div class="metric-top">
            <div class="metric-icon icon warning">
              <i class="el-icon-document" />
            </div>
            <span class="badge badge-danger">-3.5%</span>
          </div>
          <div class="metric-main">
            <div class="metric-title">回单付运费</div>
            <div class="metric-value">
              ￥
              <count-to
                :start-val="0"
                :end-val="homeData.receiptPayTotalAmount"
                :duration="2000"
              />
            </div>
          </div>
          <div class="metric-foot" aria-label="运单数量">
            <span class="metric-foot-muted">共计</span>
            <span class="metric-foot-num" style="color:#f59e0b;">
              <count-to
                :start-val="0"
                :end-val="homeData.receiptPayTotalAmount"
                :duration="2000"
            /></span>
            <span class="metric-foot-muted">单</span>
          </div>
        </div>

        <!-- 今日运费总额 -->
        <div class="card metric-card card-success">
          <div class="metric-top">
            <div class="metric-icon icon success">
              <i class="el-icon-s-finance" />
            </div>
            <span class="badge badge-success">+23.5%</span>
          </div>
          <div class="metric-main">
            <div class="metric-title">运单结算总额</div>
            <div class="metric-value money"><span>¥</span>{{ totalFee }}</div>
            <div class="metric-foot" aria-label="运单数量">
              <span class="metric-foot-muted">共计</span>
              <span class="metric-foot-num" style="color:#059669;">{{
                totalNum
              }}</span>
              <span class="metric-foot-muted">单</span>
            </div>
          </div>
          <span class="card-corner corner-success" />
        </div>
      </div>

      <div class="grid row2">
        <div class="card block span2">
          <div class="block-head">
            <div>
              <div class="block-title">实时运输流程</div>
              <div class="block-sub">全链路可视化监控中心</div>
            </div>
            <div class="legend">
              <span class="legend-item"
                ><span class="legend-dot success" />正常</span
              >
              <span class="legend-item"
                ><span class="legend-dot warning" />预警</span
              >
              <span class="legend-item"
                ><span class="legend-dot danger" />异常</span
              >
            </div>
          </div>

          <div class="flow">
            <div class="flow-step">
              <button
                class="flow-box flow-box-primary"
                type="button"
                @click="handleAction('货源发布')"
              >
                <div class="flow-count primary">
                  {{ homeData.cargoSourceCount }}
                </div>
                <div class="flow-title primary">货源发布</div>
                <span class="flow-badge flow-badge-primary">+4</span>
              </button>
              <span class="flow-line" />
            </div>
            <div class="flow-step">
              <button
                class="flow-box flow-box-default"
                type="button"
                @click="handleAction('待接单')"
              >
                <div class="flow-count">
                  {{ homeData.orderToBeAcceptedCount }}
                </div>
                <div class="flow-title">待接单</div>
              </button>
              <span class="flow-line" />
            </div>
            <div class="flow-step">
              <button
                class="flow-box flow-box-default"
                type="button"
                @click="handleAction('运输中')"
              >
                <div class="flow-count">{{ homeData.orderInTransitCount }}</div>
                <div class="flow-title">运输中</div>
                <span class="flow-pill flow-pill-secondary">智能匹配</span>
              </button>
              <span class="flow-line" />
            </div>
            <div class="flow-step">
              <button
                class="flow-box flow-box-default"
                type="button"
                @click="handleAction('已卸车')"
              >
                <div class="flow-count">{{ homeData.orderUnloadedCount }}</div>
                <div class="flow-title">已到达</div>
              </button>
              <span class="flow-line" />
            </div>
            <div class="flow-step">
              <button
                class="flow-box flow-box-success"
                type="button"
                @click="handleAction('已完成')"
              >
                <div class="flow-count">
                  {{ homeData.orderSignedCount }}
                </div>
                <div class="flow-title">已签收</div>
                <!-- <span class="flow-badge flow-badge-success">今日</span> -->
              </button>
            </div>
          </div>

          <div
            v-if="homeData && homeData.cargoSourceCount"
            class="flow-summary"
          >
            <div class="summary-item">
              <div class="summary-label">货源单总数</div>
              <div class="summary-value">
                {{ homeData.cargoSourceCount }}
              </div>
            </div>
            <div class="summary-item split">
              <div class="summary-label">运单总数</div>
              <div class="summary-value">
                {{ homeData.waybillCount }}
              </div>
            </div>
            <div class="summary-item split">
              <div class="summary-label">待装车</div>
              <div class="summary-value warning">
                {{ homeData.orderInAcceptedCount }}
              </div>
            </div>
            <div class="summary-item split">
              <div class="summary-label">已取消</div>
              <div class="summary-value muted">
                {{ homeData.orderCancelCount }}
              </div>
            </div>
          </div>
        </div>

        <div class="card block">
          <div class="block-head">
            <div>
              <div class="block-title">快捷操作</div>
              <div class="block-sub">高频业务一键直达</div>
            </div>
          </div>
          <!-- 管理员 -->
          <div v-if="isAdmin" class="shortcuts">
            <button
              class="shortcut-btn shortcut primary"
              type="button"
              @click="handleAction('司机审核')"
            >
              <div class="shortcut-icon icon primary">
                <i class="el-icon-user-solid" />
              </div>
              <div class="shortcut-title">司机审核</div>
              <div
                v-if="homeData.driverPendingReviewCount"
                class="shortcut-sub"
              >
                待审 {{ homeData.driverPendingReviewCount }}
              </div>
            </button>
            <button
              class="shortcut-btn shortcut secondary"
              type="button"
              @click="handleAction('车辆审核')"
            >
              <div class="shortcut-icon icon secondary">
                <i class="el-icon-s-goods" />
              </div>
              <div class="shortcut-title">车辆审核</div>
              <div
                v-if="homeData.vehiclePendingReviewCount"
                class="shortcut-sub"
              >
                待审 {{ homeData.vehiclePendingReviewCount }}
              </div>
            </button>
            <button
              class="shortcut-btn shortcut"
              type="button"
              @click="handleAction('货源管理')"
            >
              <div class="shortcut-icon icon">
                <i class="el-icon-box" />
              </div>
              <div class="shortcut-title">货源管理</div>
              <div v-if="homeData.cargoSourceCount" class="shortcut-sub">
                管理 {{ homeData.cargoSourceCount }}
              </div>
            </button>
            <button
              class="shortcut-btn shortcut orange"
              type="button"
              @click="handleAction('运单跟踪')"
            >
              <div class="shortcut-icon icon orange">
                <i class="el-icon-s-order" />
              </div>
              <div class="shortcut-title">运单跟踪</div>
              <div
                v-if="homeData && homeData.waybillCount"
                class="shortcut-sub"
              >
                追踪 {{ homeData.waybillCount }}
              </div>
            </button>
          </div>
          <!-- 货主层 -->
          <div v-else class="shortcuts">
            <button
              class="shortcut-btn shortcut primary"
              type="button"
              @click="handleAction('发布货源')"
            >
              <div class="shortcut-icon icon primary">
                <i class="el-icon-circle-plus" />
              </div>
              <div class="shortcut-title">发布货源</div>
            </button>
            <button
              class="shortcut-btn shortcut secondary"
              type="button"
              @click="handleAction('货源管理')"
            >
              <div class="shortcut-icon icon secondary">
                <i class="el-icon-box" />
              </div>
              <div class="shortcut-title">货源管理</div>
            </button>
            <button
              class="shortcut-btn shortcut orange"
              type="button"
              @click="handleAction('运单跟踪')"
            >
              <div class="shortcut-icon icon orange">
                <i class="el-icon-s-order" />
              </div>
              <div class="shortcut-title">运单跟踪</div>
            </button>
            <button
              class="shortcut-btn shortcut success"
              type="button"
              @click="handleAction('运单管理')"
            >
              <div class="shortcut-icon icon success">
                <i class="el-icon-document" />
              </div>
              <div class="shortcut-title">运单管理</div>
            </button>
          </div>
        </div>
      </div>

      <div v-if="isAdmin" class="grid row3">
        <div class="card block span2">
          <div class="block-head">
            <div>
              <div class="block-title">运力结构分析</div>
              <div class="block-sub">司机与车辆实时构成</div>
            </div>
          </div>

          <div class="capacity">
            <div class="cap-item">
              <div class="donut">
                <svg viewBox="0 0 36 36" class="donut-svg">
                  <path
                    class="donut-bg"
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                  />
                  <path
                    class="donut-fg primary"
                    :stroke-dasharray="dashArray(capacity.driver.percent)"
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                  />
                </svg>
                <div class="donut-center">
                  <div
                    v-if="homeData && homeData.driverCount"
                    class="donut-value"
                  >
                    {{ homeData.driverCount }}
                  </div>
                  <div class="donut-label">注册司机</div>
                </div>
              </div>
              <div class="cap-bars">
                <div class="cap-bar">
                  <div class="cap-bar-head">
                    <span class="cap-bar-label">今日新增</span>
                    <span class="cap-bar-value">+18</span>
                  </div>
                  <div class="progress">
                    <div
                      class="progress-fill fill primary"
                      style="width: 15%"
                    />
                  </div>
                </div>
                <div class="cap-bar">
                  <div class="cap-bar-head">
                    <span class="cap-bar-label">待审核</span>
                    <span class="cap-bar-value">{{
                      homeData.driverPendingReviewCount
                    }}</span>
                  </div>
                  <div class="progress">
                    <div class="progress-fill fill warning" style="width: 8%" />
                  </div>
                </div>
              </div>
            </div>

            <div class="cap-item split">
              <div class="donut">
                <svg viewBox="0 0 36 36" class="donut-svg">
                  <path
                    class="donut-bg"
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                  />
                  <path
                    class="donut-fg secondary"
                    :stroke-dasharray="dashArray(capacity.vehicle.percent)"
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                  />
                </svg>
                <div class="donut-center">
                  <div class="donut-value">
                    {{ homeData.vehicleCount }}
                  </div>
                  <div class="donut-label">注册车辆</div>
                </div>
              </div>
              <div class="cap-bars">
                <div class="cap-bar">
                  <div class="cap-bar-head">
                    <span class="cap-bar-label">今日新增</span>
                    <span class="cap-bar-value">+24</span>
                  </div>
                  <div class="progress">
                    <div
                      class="progress-fill fill secondary"
                      style="width: 18%"
                    />
                  </div>
                </div>
                <div class="cap-bar">
                  <div class="cap-bar-head">
                    <span class="cap-bar-label">待审核</span>
                    <span class="cap-bar-value">{{
                      homeData.vehiclePendingReviewCount
                    }}</span>
                  </div>
                  <div class="progress">
                    <div class="progress-fill fill warning" style="width: 5%" />
                  </div>
                </div>
                <div class="cap-bar">
                  <div class="cap-bar-head">
                    <span class="cap-bar-label">总运力</span>
                    <span class="cap-bar-value">{{ weightSum }}吨</span>
                  </div>
                  <div class="progress">
                    <div
                      class="progress-fill fill success"
                      style="width: 72%"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card block">
          <div class="block-head between">
            <div class="block-title">实时待办</div>
            <div class="pill-danger">{{ formatNumber(todo.total) }} 待处理</div>
          </div>

          <div class="todo">
            <div class="todo-item" @click="handleAction('司机审核')">
              <div class="todo-left">
                <div class="todo-icon icon primary">
                  <i class="el-icon-user-solid" />
                </div>
                <div>
                  <div class="todo-title">司机实名认证审核</div>
                  <div class="todo-sub">
                    新增待审 {{ homeData.driverPendingReviewCount }} 人
                  </div>
                </div>
              </div>
              <button
                class="todo-btn btn primary"
                type="button"
                @click.stop="handleAction('司机审核')"
              >
                立即审核
              </button>
            </div>
            <div class="todo-item" @click="handleAction('车辆审核')">
              <div class="todo-left">
                <div class="todo-icon icon secondary">
                  <i class="el-icon-s-goods" />
                </div>
                <div>
                  <div class="todo-title">车辆资质审核</div>
                  <div class="todo-sub">
                    新增待审 {{ homeData.vehiclePendingReviewCount }} 辆
                  </div>
                </div>
              </div>
              <button
                class="todo-btn btn secondary"
                type="button"
                @click.stop="handleAction('车辆审核')"
              >
                立即审核
              </button>
            </div>
            <div class="todo-item" @click="handleAction('运单审核')">
              <div class="todo-left">
                <div class="todo-icon icon warning">
                  <i class="el-icon-s-order" />
                </div>
                <div>
                  <div class="todo-title">异常运单复核</div>
                  <div class="todo-sub">
                    待复核 {{ homeData.orderAbnormalCount }} 单
                  </div>
                </div>
              </div>
              <button
                class="todo-btn btn warning"
                type="button"
                style="color: #fff;"
                @click.stop="handleAction('异常运单')"
              >
                立即处理
              </button>
            </div>
            <div class="todo-item" @click="handleAction('待装车')">
              <div class="todo-left">
                <div class="todo-icon icon orange">
                  <i class="el-icon-box" />
                </div>
                <div>
                  <div class="todo-title">待装车运单</div>
                  <div class="todo-sub">
                    等待调度 {{ homeData.orderInAcceptedCount }} 单
                  </div>
                </div>
              </div>
              <button
                class="todo-btn btn orange"
                type="button"
                @click.stop="handleAction('待装车')"
              >
                去调度
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="grid row4">
        <div class="card block">
          <div class="block-title">货源状态分布</div>
          <div class="dist">
            <div class="dist-item">
              <div class="dist-head">
                <div class="dist-label">
                  <span class="dist-dot primary" />待接单
                </div>
                <div class="dist-value">
                  {{ homeData.orderToBeAcceptedCount }}
                  <span class="dist-total"
                    >/ {{ homeData.cargoSourceCount }}</span
                  >
                </div>
              </div>
              <div class="progress big">
                <div
                  class="progress-fill fill primary"
                  :style="{
                    width:
                      `${(homeData.orderToBeAcceptedCount /
                        homeData.cargoSourceCount) *
                        100}` + '%'
                  }"
                />
              </div>
            </div>
            <div class="dist-item">
              <div class="dist-head">
                <div class="dist-label">
                  <span class="dist-dot secondary" />运输中
                </div>
                <div class="dist-value">
                  {{ homeData.cargoSourceInTransitCount }}
                  <span class="dist-total"
                    >/ {{ homeData.cargoSourceCount }}</span
                  >
                </div>
              </div>
              <div class="progress big">
                <div
                  class="progress-fill fill secondary"
                  :style="{
                    width:
                      `${(homeData.cargoSourceInTransitCount /
                        homeData.cargoSourceCount) *
                        100}` + '%'
                  }"
                />
              </div>
            </div>
            <div class="dist-item">
              <div class="dist-head">
                <div class="dist-label">
                  <span class="dist-dot success" />已完成
                </div>
                <div class="dist-value">
                  {{ homeData.orderFinishedCount }}
                  <span class="dist-total"
                    >/ {{ homeData.cargoSourceCount }}</span
                  >
                </div>
              </div>
              <div class="progress big">
                <div
                  class="progress-fill fill success"
                  :style="{
                    width:
                      `${(homeData.orderFinishedCount /
                        homeData.cargoSourceCount) *
                        100}` + '%'
                  }"
                />
              </div>
            </div>
            <div class="dist-item">
              <div class="dist-head">
                <div class="dist-label">
                  <span class="dist-dot muted" />已取消
                </div>
                <div class="dist-value">
                  {{ homeData.orderCancelCount }}
                  <span class="dist-total"
                    >/ {{ homeData.cargoSourceCount }}</span
                  >
                </div>
              </div>
              <div class="progress big">
                <div
                  class="progress-fill fill muted"
                  :style="{
                    width:
                      `${(homeData.orderCancelCount /
                        homeData.cargoSourceCount) *
                        100}` + '%'
                  }"
                />
              </div>
            </div>
          </div>
          <div class="dist-foot">
            <div class="mini-card">
              <div class="mini-label">发布货源总数</div>
              <div class="mini-value primary">
                {{ homeData.cargoSourceCount }}
              </div>
            </div>
            <div class="mini-card">
              <div class="mini-label">今日新增</div>
              <div class="mini-value primary">
                +4
              </div>
            </div>
          </div>
        </div>

        <div class="card block">
          <div class="block-title">运单状态分布</div>
          <div class="dist">
            <div class="dist-item">
              <div class="dist-head">
                <div class="dist-label">
                  <span class="dist-dot warning" />待装车
                </div>
                <div class="dist-value">
                  {{ homeData.orderInAcceptedCount }}
                  <span class="dist-total">/ {{ homeData.waybillCount }}</span>
                </div>
              </div>
              <div class="progress big">
                <div
                  class="progress-fill fill warning"
                  :style="{
                    width:
                      `${(homeData.orderInAcceptedCount /
                        homeData.waybillCount) *
                        100}` + '%'
                  }"
                />
              </div>
            </div>
            <div class="dist-item">
              <div class="dist-head">
                <div class="dist-label">
                  <span class="dist-dot secondary" />运输中
                </div>
                <div class="dist-value">
                  {{ homeData.orderInTransitCount }}
                  <span class="dist-total">/ {{ homeData.waybillCount }}</span>
                </div>
              </div>
              <div class="progress big">
                <div
                  class="progress-fill fill secondary"
                  :style="{
                    width:
                      `${(homeData.orderInTransitCount /
                        homeData.waybillCount) *
                        100}` + '%'
                  }"
                />
              </div>
            </div>
            <div class="dist-item">
              <div class="dist-head">
                <div class="dist-label">
                  <span class="dist-dot orange" />已到达
                </div>
                <div class="dist-value">
                  {{ homeData.orderUnloadedCount }}
                  <span class="dist-total">/ {{ homeData.waybillCount }}</span>
                </div>
              </div>
              <div class="progress big">
                <div
                  class="progress-fill fill orange"
                  :style="{
                    width:
                      `${(homeData.orderUnloadedCount / homeData.waybillCount) *
                        100}` + '%'
                  }"
                />
              </div>
            </div>
            <div class="dist-item">
              <div class="dist-head">
                <div class="dist-label">
                  <span class="dist-dot success" />已签收
                </div>
                <div class="dist-value">
                  {{ homeData.orderSignedCount }}
                  <span class="dist-total">/ {{ homeData.waybillCount }}</span>
                </div>
              </div>
              <div class="progress big">
                <div
                  class="progress-fill fill success"
                  :style="{
                    width:
                      `${(homeData.orderSignedCount / homeData.waybillCount) *
                        100}` + '%'
                  }"
                />
              </div>
            </div>
          </div>
          <div class="dist-foot">
            <div class="mini-card">
              <div class="mini-label">运单总数</div>
              <div class="mini-value secondary">
                {{ homeData.waybillCount }}
              </div>
            </div>
            <div class="mini-card">
              <div class="mini-label">完成率</div>
              <div
                v-if="homeData && homeData.orderSignedCount"
                class="mini-value"
              >
                {{
                  (
                    (homeData.orderSignedCount / homeData.waybillCount) *
                    100
                  ).toFixed(2)
                }}%
              </div>
            </div>
          </div>
        </div>

        <div class="card block">
          <div class="block-title">核心交易数据</div>
          <div class="trade">
            <div class="trade-item trade-bg secondary">
              <div class="trade-icon icon secondary">
                <i class="el-icon-bank-card" />
              </div>
              <div>
                <div class="trade-label">交易总额(元)</div>
                <div class="trade-value">{{ totalFee || 0 }}</div>
              </div>
            </div>
            <div class="trade-item trade-bg danger">
              <div class="trade-icon icon danger">
                <i class="el-icon-money" />
              </div>
              <div>
                <div class="trade-label">运费总额(元)</div>
                <div class="trade-value">
                  {{ totalFee || 0 }}
                </div>
              </div>
            </div>
            <div class="trade-item trade-bg primary">
              <div class="trade-icon icon primary">
                <i class="el-icon-s-ticket" />
              </div>
              <div>
                <div class="trade-label">开票总额(元)</div>
                <div class="trade-value">{{ invoiceFeeSum }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getFeeStatistics,
  getOrderCountStatistics,
  getVehicleCountStatistics
} from "@/api/statistics";
import CountTo from "vue-count-to";

export default {
  name: "Ab",
  components: {
    CountTo
  },
  data() {
    return {
      invoiceFeeSum: 0,
      allFeeSum: 0,
      homeData: {},
      isAdmin: false,
      deliveryCashFee: 0,
      weightSum: 0,
      vehicleCount: 0,
      animatedNumbers: {
        vehicleTotal: 0,
        driverTotal: 0,
        freightToday: 0
      },
      todoCount: 47,
      flowSummary: {
        goodsTotal: 5736,
        waybillTotal: 16320,
        waitLoad: 139,
        canceled: 28
      },
      capacity: {
        driver: {
          total: 38920,
          percent: 85
        },
        vehicle: {
          total: 43333,
          percent: 92,
          bars: [
            {
              label: "今日新增",
              value: "+24",
              percent: 18,
              fillClass: "fill secondary",
              valueClass: ""
            },
            {
              label: "待审核",
              value: "8",
              percent: 5,
              fillClass: "fill warning",
              valueClass: "warning"
            },
            {
              label: "总运力",
              value: "149.6万吨",
              percent: 72,
              fillClass: "fill success",
              valueClass: ""
            }
          ]
        }
      },
      todo: {
        total: 47
      },
      goodsDist: {
        total: 5736,
        todayAdd: 24,
        items: [
          {
            label: "待接单",
            value: 411,
            percent: 7.2,
            dotClass: "primary",
            fillClass: "fill primary"
          },
          {
            label: "运输中",
            value: 485,
            percent: 8.5,
            dotClass: "secondary",
            fillClass: "fill secondary"
          },
          {
            label: "已完成",
            value: 755,
            percent: 13.2,
            dotClass: "success",
            fillClass: "fill success"
          },
          {
            label: "已取消",
            value: 28,
            percent: 0.5,
            dotClass: "muted",
            fillClass: "fill muted"
          }
        ]
      }
    };
  },
  computed: {
    metricValueMap() {
      return {
        vehicleTotal: 43333,
        driverTotal: 38920,
        freightToday: 1284000
      };
    },
    totalFee() {
      return (
        this.homeData.arrivePayTotalAmount +
          this.homeData.prepayTotalAmount +
          this.homeData.receiptPayTotalAmount || 0
      );
    },
    totalNum() {
      return (
        this.homeData.arrivePayCount +
          +this.homeData.prepayCount +
          this.homeData.receiptPayCount || 0
      );
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.renderTrendChart();
      this.renderStatusChart();
      window.addEventListener("resize", this.handleResize, { passive: true });
    });
    let data = this.isAdmin ? {} : { isShipper: false };
    getFeeStatistics(data).then(response => {
      let data = response.data;
      this.allFeeSum = data.allFeeSum ? data.allFeeSum : 0; //运费交易总额（元）
      this.invoiceFeeSum = data.invoiceFeeSum ? data.invoiceFeeSum : 0; //开发票总额（元）
      this.paidAmountSum = data.paidAmountSum ? data.paidAmountSum : 0; //充值总额（元）
      this.deliveryCashFee = data.deliveryCashFee ? data.deliveryCashFee : 0; //司机放款总额（元）
      this.verifycodeCount = data.verifycodeCount ? data.verifycodeCount : 0; //短信消费总计(条）
    });
    getOrderCountStatistics().then(response => {
      let data = response.data;
      this.orderCount = data.orderCount ? data.orderCount : 0; //货源单总数
      this.kpis.forEach(item => {
        if (item.key == "loads") {
          item.value = data.orderCount;
          item.meta.forEach(meta => {
            if (meta.k == "已接单") {
              meta.v = data.orderRecieveCount;
            } else if (meta.k == "未接单") {
              meta.v = +data.orderNotRecieveCount;
            }
          });
        }
      });
      this.orderNotRecieveCount = data.orderNotRecieveCount
        ? data.orderNotRecieveCount
        : 0; //未接单
      this.orderRecieveCount = data.orderRecieveCount
        ? data.orderRecieveCount
        : 0; //已接单
      this.orderPayCount = data.orderPayCount ? data.orderPayCount : 0; //已结算
      this.orderCancelCount = data.orderCancelCount ? data.orderCancelCount : 0; //已撤销
      this.orderCountNoQuote = data.orderCountNoQuote
        ? data.orderCountNoQuote
        : 0; //正常单
      this.orderCountQuote = data.orderCountQuote ? data.orderCountQuote : 0; //报价单
      this.orderDetailCount = data.orderDetailCount ? data.orderDetailCount : 0; //运输单总数
      this.waitOrderDetailCount = data.waitOrderDetailCount
        ? data.waitOrderDetailCount
        : 0; //待运输
      this.transOrderDetailCount = data.transOrderDetailCount
        ? data.transOrderDetailCount
        : 0; //运输中
      this.sighOrderDetailCount = data.sighOrderDetailCount
        ? data.sighOrderDetailCount
        : 0; //已卸货
      this.flowNodes.forEach(item => {
        if (item.key == "orders") {
          item.value = data.orderDetailCount;
          item.hint = data.transOrderDetailCount + "单运输中";
        }
      });
      this.$nextTick(() => {
        this.renderTrendChart();
      });
    });
    getVehicleCountStatistics().then(response => {
      let data = response.data;
      this.homeData = data;
      this.vehicleCount = data.vehicleCount ? data.vehicleCount : 0;
      this.weightSum = data.weightSum ? data.weightSum : 0;
    });
    this.startAnimateNumbers();
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    this.isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
  },
  methods: {
    dashArray(percent) {
      const safe = Math.max(0, Math.min(100, Number(percent) || 0));
      return `${safe}, 100`;
    },
    formatNumber(val) {
      const num = Number(val);
      if (!Number.isFinite(num)) return String(val || "");
      return num.toLocaleString();
    },
    handleAction(name) {
      if (name == "司机审核") {
        this.$router.push("/review/carrierReview");
      } else if (name == "车辆审核") {
        this.$router.push("/review/vehicleReview");
      } else if (name == "货源管理") {
        this.$router.push("/order/order_manage");
      } else if (name == "运单跟踪") {
        this.$router.push("/transportManage/waybillManage");
      } else if (name == "异常运单") {
        this.$router.push("/transportManage/AbnormalWaybill");
      } else if (name == "待装车") {
        this.$router.push("/transportManage/waybillManage");
      } else if (name == "发布货源") {
        this.$router.push("/order/order_publish");
      } else if (name == "运单管理") {
        this.$router.push("/transportManage/Transport");
      }
    },
    startAnimateNumbers() {
      const duration = 800;
      const start = performance.now();
      const from = { ...this.animatedNumbers };
      const to = {
        vehicleTotal: this.metricValueMap.vehicleTotal,
        driverTotal: this.metricValueMap.driverTotal,
        freightToday: this.metricValueMap.freightToday
      };
      const step = now => {
        const p = Math.min(1, (now - start) / duration);
        const ease = 1 - Math.pow(1 - p, 3);
        this.animatedNumbers.vehicleTotal = Math.round(
          from.vehicleTotal + (to.vehicleTotal - from.vehicleTotal) * ease
        );
        this.animatedNumbers.driverTotal = Math.round(
          from.driverTotal + (to.driverTotal - from.driverTotal) * ease
        );
        this.animatedNumbers.freightToday = Math.round(
          from.freightToday + (to.freightToday - from.freightToday) * ease
        );
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
  }
};
</script>

<style scoped>
.ab-page {
  --primary: #6b46c1;
  --primary-light: #8b5cf6;
  --secondary: #3b82f6;
  --success: #10b981;
  --warning: #f59e0b;
  --danger: #ef4444;
  --orange: #f97316;
  --bg: #f8fafc;
  --card: #ffffff;
  --text: #0f172a;
  --muted: #64748b;
  --line: rgba(15, 23, 42, 0.08);
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  color: var(--text);
  background: var(--bg);
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, "Noto Sans", "PingFang SC", "Microsoft YaHei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ab-page *,
.ab-page *::before,
.ab-page *::after {
  box-sizing: inherit;
}

.page-inner {
  max-width: 1600px;
  margin: 0 auto;
  padding: 16px 24px 24px;
}

.grid {
  display: grid;
  gap: 16px;
}

.metrics {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.row2,
.row3,
.row4 {
  margin-top: 16px;
}

.row2,
.row3,
.row4 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.span2 {
  grid-column: span 2 / span 2;
}

.card {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 1px 1px rgba(15, 23, 42, 0.04);
  position: relative;
  overflow: hidden;
}

.card-corner {
  position: absolute;
  right: -32px;
  top: -32px;
  width: 140px;
  height: 140px;
  border-bottom-left-radius: 140px;
  pointer-events: none;
  opacity: 0.6;
}

.corner-primary {
  background: radial-gradient(
    closest-side,
    rgba(107, 70, 193, 0.18),
    rgba(107, 70, 193, 0)
  );
}

.corner-secondary {
  background: radial-gradient(
    closest-side,
    rgba(59, 130, 246, 0.18),
    rgba(59, 130, 246, 0)
  );
}

.corner-warning {
  background: radial-gradient(
    closest-side,
    rgba(245, 158, 11, 0.18),
    rgba(245, 158, 11, 0)
  );
}

.corner-success {
  background: radial-gradient(
    closest-side,
    rgba(16, 185, 129, 0.18),
    rgba(16, 185, 129, 0)
  );
}

.metric-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.metric-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 24px rgba(107, 70, 193, 0.08);
}

.metric-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.metric-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(100, 116, 139, 0.08);
}

.metric-icon > i {
  font-size: 20px;
  line-height: 1;
}

.metric-icon.icon.primary > i {
  color: var(--primary);
}

.metric-icon.icon.secondary > i {
  color: var(--secondary);
}

.metric-icon.icon.warning > i {
  color: var(--warning);
}

.metric-icon.icon.success > i {
  color: #059669;
}

.metric-icon.icon.danger > i {
  color: var(--danger);
}

.metric-icon.icon.orange > i {
  color: #ea580c;
}

.icon-dot {
  width: 16px;
  height: 16px;
  border-radius: 999px;
  background: rgba(100, 116, 139, 0.35);
}

.icon.primary {
  background: rgba(107, 70, 193, 0.1);
}

.icon.secondary {
  background: rgba(59, 130, 246, 0.1);
}

.icon.success {
  background: rgba(16, 185, 129, 0.12);
}

.icon.warning {
  background: rgba(245, 158, 11, 0.12);
}

.icon.danger {
  background: rgba(239, 68, 68, 0.12);
}

.icon.orange {
  background: rgba(249, 115, 22, 0.12);
}

.dot.primary {
  background: var(--primary);
}

.dot.secondary {
  background: var(--secondary);
}

.dot.success {
  background: var(--success);
}

.dot.warning {
  background: var(--warning);
}

.dot.danger {
  background: var(--danger);
}

.dot.orange {
  background: var(--orange);
}

.badge {
  font-size: 12px;
  line-height: 18px;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid var(--line);
  background: rgba(148, 163, 184, 0.12);
  color: var(--muted);
  font-weight: 600;
}

.badge-success {
  background: rgba(16, 185, 129, 0.08);
  border-color: rgba(16, 185, 129, 0.18);
  color: #047857;
}

.badge-danger {
  background: rgba(239, 68, 68, 0.08);
  border-color: rgba(239, 68, 68, 0.18);
  color: #b91c1c;
}

.metric-title {
  font-size: 13px;
  color: var(--muted);
  font-weight: 600;
  margin-bottom: 6px;
}

.metric-value {
  font-size: 28px;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
}

.metric-value.money {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.metric-sub {
  margin-top: 8px;
  font-size: 12px;
  color: #94a3b8;
  display: flex;
  align-items: center;
  gap: 8px;
}

.metric-foot {
  margin-top: 10px;
  display: inline-flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 2px 4px;
  font-size: 12px;
  line-height: 1.35;
}

.metric-foot-muted {
  color: #94a3b8;
  font-weight: 500;
}

.metric-foot-num {
  font-size: 16px;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
  color: var(--primary);
}

.metric-sub-strong {
  font-weight: 700;
}

.metric-sub-strong.primary {
  color: var(--primary);
}

.metric-sub-strong.secondary {
  color: var(--secondary);
}

.metric-sub-strong.success {
  color: var(--success);
}

.metric-sub-split {
  color: rgba(148, 163, 184, 0.8);
}

.progress-mini {
  width: 72px;
  height: 6px;
  border-radius: 999px;
  overflow: hidden;
  background: rgba(148, 163, 184, 0.18);
}

.progress-mini-fill {
  height: 100%;
  display: block;
  background: var(--success);
  border-radius: 999px;
}

.metric-tags {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 12px;
  color: #475569;
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.tag-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.8);
}

.tag-dot.primary {
  background: var(--primary);
}

.tag-dot.secondary {
  background: var(--secondary);
}

.tag-dot.warning {
  background: var(--warning);
}

.tag-dot.success {
  background: var(--success);
}

.block {
  padding: 18px;
}

.block-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.block-head.between {
  margin-bottom: 12px;
}

.block-title {
  font-size: 16px;
  font-weight: 800;
  color: var(--text);
}

.block-sub {
  margin-top: 2px;
  font-size: 12px;
  color: #94a3b8;
}

.legend {
  display: flex;
  gap: 14px;
  font-size: 12px;
  color: #475569;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
}

.legend-dot.success {
  background: var(--success);
}

.legend-dot.warning {
  background: var(--warning);
}

.legend-dot.danger {
  background: var(--danger);
}

.flow {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  align-items: center;
}

.flow-step {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flow-line {
  position: absolute;
  right: -12px;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(
    90deg,
    rgba(107, 70, 193, 0.8),
    rgba(59, 130, 246, 0.8)
  );
}

.flow-box {
  width: 100%;
  max-width: 110px;
  aspect-ratio: 1 / 1;
  border-radius: 16px;
  border: 2px solid rgba(148, 163, 184, 0.25);
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  padding: 8px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.flow-box:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 24px rgba(15, 23, 42, 0.06);
}

.flow-box:active {
  transform: translateY(0);
}

.flow-box-primary {
  border-color: rgba(107, 70, 193, 0.25);
  background: linear-gradient(
    135deg,
    rgba(107, 70, 193, 0.12),
    rgba(107, 70, 193, 0.05)
  );
}

.flow-box-success {
  border-color: rgba(16, 185, 129, 0.28);
  background: linear-gradient(
    135deg,
    rgba(16, 185, 129, 0.12),
    rgba(255, 255, 255, 1)
  );
}

.flow-count {
  font-size: 22px;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
}

.flow-count.primary {
  color: var(--primary);
}

.flow-count.success {
  color: #059669;
}

.flow-title {
  font-size: 12px;
  margin-top: 4px;
  color: #64748b;
  font-weight: 600;
}

.flow-title.primary {
  color: rgba(107, 70, 193, 0.85);
}

.flow-title.success {
  color: rgba(5, 150, 105, 0.85);
}

.flow-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 999px;
  color: #fff;
  font-weight: 700;
}

.flow-badge-primary {
  background: var(--primary);
}

.flow-badge-success {
  background: var(--success);
}

.flow-pill {
  position: absolute;
  bottom: 7px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid rgba(59, 130, 246, 0.18);
  background: rgba(59, 130, 246, 0.08);
  color: var(--secondary);
  font-weight: 700;
  white-space: nowrap;
}

.flow-summary {
  margin-top: 40px;
  padding-top: 14px;
  border-top: 1px solid var(--line);
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.summary-item {
  text-align: center;
}

.summary-item.split {
  border-left: 1px solid var(--line);
}

.summary-label {
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 4px;
  font-weight: 600;
}

.summary-value {
  font-size: 18px;
  font-weight: 900;
  color: #1f2937;
  font-variant-numeric: tabular-nums;
}

.summary-value.warning {
  color: var(--warning);
}

.summary-value.muted {
  color: #64748b;
}

.shortcuts {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.shortcut-btn {
  border-radius: 14px;
  padding: 14px 10px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  background: rgba(148, 163, 184, 0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.shortcut-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 24px rgba(15, 23, 42, 0.06);
}

.shortcut-btn:active {
  transform: translateY(0);
}

.shortcut-btn.shortcut.primary {
  border-color: rgba(107, 70, 193, 0.2);
  background: linear-gradient(
    135deg,
    rgba(107, 70, 193, 0.06),
    rgba(107, 70, 193, 0.12)
  );
  color: var(--primary);
}

.shortcut-btn.shortcut.secondary {
  border-color: rgba(59, 130, 246, 0.2);
  background: linear-gradient(
    135deg,
    rgba(59, 130, 246, 0.06),
    rgba(59, 130, 246, 0.12)
  );
  color: var(--secondary);
}

.shortcut-btn.shortcut.success {
  border-color: rgba(16, 185, 129, 0.25);
  background: linear-gradient(
    135deg,
    rgba(16, 185, 129, 0.06),
    rgba(16, 185, 129, 0.12)
  );
  color: #059669;
}

.shortcut-btn.shortcut.orange {
  border-color: rgba(249, 115, 22, 0.24);
  background: linear-gradient(
    135deg,
    rgba(249, 115, 22, 0.06),
    rgba(249, 115, 22, 0.12)
  );
  color: #ea580c;
}

.shortcut-icon {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.shortcut-icon > i {
  font-size: 20px;
  line-height: 1;
  color: inherit;
}

.shortcut-title {
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
}

.shortcut-sub {
  font-size: 11px;
  opacity: 0.75;
}

.ai-tip {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.16);
  background: rgba(148, 163, 184, 0.06);
  display: flex;
  align-items: center;
  gap: 10px;
}

.ai-text {
  font-size: 12px;
  color: #475569;
}

.ai-strong {
  color: var(--primary);
  font-weight: 900;
}

.ai-link {
  margin-left: auto;
  border: none;
  background: transparent;
  color: var(--primary);
  font-weight: 800;
  cursor: pointer;
}

.capacity {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.cap-item {
  flex-direction: column;
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 16px;
  align-items: center;
}

.cap-item.split {
  border-left: 1px solid var(--line);
  padding-left: 16px;
}

.donut {
  width: 128px;
  height: 128px;
  position: relative;
}

.donut-svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.donut-bg {
  fill: none;
  stroke: rgba(148, 163, 184, 0.18);
  stroke-width: 3;
}

.donut-fg {
  fill: none;
  stroke-width: 3;
  stroke-linecap: round;
}

.donut-fg.primary {
  stroke: var(--primary);
}

.donut-fg.secondary {
  stroke: var(--secondary);
}

.donut-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.donut-value {
  font-size: 18px;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
}

.donut-label {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
}

.cap-bars {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cap-bar-head {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 13px;
  margin-bottom: 6px;
}

.cap-bar-label {
  color: #64748b;
  font-weight: 600;
}

.cap-bar-value {
  color: #0f172a;
  font-weight: 900;
}

.cap-bar-value.warning {
  color: var(--warning);
}

.cap-bar-value.success {
  color: #059669;
}

.progress {
  width: 100%;
  height: 8px;
  border-radius: 999px;
  overflow: hidden;
  background: rgba(148, 163, 184, 0.18);
}

.progress.big {
  height: 10px;
}

.progress-fill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.6s ease;
}

.fill.primary {
  background: var(--primary);
}

.fill.secondary {
  background: var(--secondary);
}

.fill.success {
  background: var(--success);
}

.fill.warning {
  background: var(--warning);
}

.fill.muted {
  background: rgba(148, 163, 184, 0.85);
}

.fill.orange {
  background: var(--orange);
}

.todo {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pill-danger {
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 999px;
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.18);
  color: #b91c1c;
  font-weight: 800;
}

.todo-item {
  padding: 12px;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.14);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.todo-item:hover {
  background: rgba(148, 163, 184, 0.06);
  border-color: rgba(107, 70, 193, 0.18);
}

.todo-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.todo-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.todo-icon > i {
  font-size: 18px;
  line-height: 1;
}

.todo-icon.icon.primary > i {
  color: var(--primary);
}

.todo-icon.icon.secondary > i {
  color: var(--secondary);
}

.todo-icon.icon.warning > i {
  color: var(--warning);
}

.todo-icon.icon.orange > i {
  color: #ea580c;
}

.todo-title {
  font-size: 14px;
  font-weight: 900;
  color: #0f172a;
}

.todo-sub {
  margin-top: 2px;
  font-size: 12px;
  color: #94a3b8;
}

.todo-btn {
  border: none;
  border-radius: 10px;
  padding: 8px 10px;
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}

.todo-btn.btn.primary {
  background: var(--primary);
}

.todo-btn.btn.secondary {
  background: var(--secondary);
}

.todo-btn.btn.warning {
  background: var(--warning);
}

.todo-btn.btn.orange {
  background: var(--orange);
}

.dist {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.dist-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 8px;
}

.dist-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #475569;
  font-weight: 700;
  font-size: 13px;
}

.dist-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.8);
}

.dist-dot.primary {
  background: var(--primary);
}

.dist-dot.secondary {
  background: var(--secondary);
}

.dist-dot.success {
  background: var(--success);
}

.dist-dot.warning {
  background: var(--warning);
}

.dist-dot.orange {
  background: var(--orange);
}

.dist-dot.muted {
  background: rgba(148, 163, 184, 0.85);
}

.dist-value {
  color: #0f172a;
  font-weight: 900;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}

.dist-total {
  color: #94a3b8;
  font-weight: 700;
  margin-left: 4px;
  font-size: 12px;
}

.dist-foot {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--line);
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.mini-card {
  border-radius: 14px;
  background: rgba(148, 163, 184, 0.06);
  border: 1px solid rgba(148, 163, 184, 0.14);
  padding: 12px;
  text-align: center;
}

.mini-label {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 700;
}

.mini-value {
  margin-top: 6px;
  font-size: 18px;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
}

.mini-value.primary {
  color: var(--primary);
}

.mini-value.secondary {
  color: var(--secondary);
}

.mini-value.success {
  color: #059669;
}

.trade {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.trade-item {
  border-radius: 14px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid rgba(148, 163, 184, 0.14);
  margin-bottom: 15px;
}

.trade-bg.orange {
  background: linear-gradient(
    90deg,
    rgba(249, 115, 22, 0.08),
    rgba(255, 255, 255, 0)
  );
  border-color: rgba(249, 115, 22, 0.18);
}

.trade-bg.secondary {
  background: linear-gradient(
    90deg,
    rgba(59, 130, 246, 0.08),
    rgba(255, 255, 255, 0)
  );
  border-color: rgba(59, 130, 246, 0.16);
}

.trade-bg.danger {
  background: linear-gradient(
    90deg,
    rgba(239, 68, 68, 0.08),
    rgba(255, 255, 255, 0)
  );
  border-color: rgba(239, 68, 68, 0.16);
}

.trade-bg.primary {
  background: linear-gradient(
    90deg,
    rgba(107, 70, 193, 0.08),
    rgba(255, 255, 255, 0)
  );
  border-color: rgba(107, 70, 193, 0.16);
}

.trade-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.trade-icon > i {
  font-size: 20px;
  line-height: 1;
}

.trade-icon.icon.orange > i {
  color: #ea580c;
}

.trade-icon.icon.secondary > i {
  color: var(--secondary);
}

.trade-icon.icon.danger > i {
  color: #dc2626;
}

.trade-icon.icon.primary > i {
  color: var(--primary);
}

.trade-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 700;
}

.trade-value {
  margin-top: 4px;
  font-size: 16px;
  font-weight: 900;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

.trade-foot {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--line);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.online {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #64748b;
  font-weight: 700;
}

.online-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--success);
}

.online-strong {
  color: #0f172a;
  font-weight: 900;
}

.trade-time {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 700;
}

.warning {
  color: var(--warning);
}

.success {
  color: #059669;
}

@media (max-width: 1200px) {
  .metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .row2,
  .row3,
  .row4 {
    grid-template-columns: 1fr;
  }
  .span2 {
    grid-column: auto;
  }
  .capacity {
    grid-template-columns: 1fr;
  }
  .cap-item.split {
    border-left: none;
    padding-left: 0;
    border-top: 1px solid var(--line);
    padding-top: 16px;
  }
}

@media (max-width: 520px) {
  .page-inner {
    padding: 12px 12px 16px;
  }
  .metrics {
    grid-template-columns: 1fr;
  }
  .flow {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .flow-line {
    display: none;
  }
  .flow-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .summary-item.split {
    border-left: none;
  }
}
</style>
